export const ALLOCATION_PLANS_ROUTE_SEGMENTS = {
  root: 'plans',
  lumpsum: 'lumpsum',
  sip: 'sip'
} as const

const ALLOCATION_ROOT = '/allocation'
const ALLOCATION_PLANS_ROOT = `${ALLOCATION_ROOT}/${ALLOCATION_PLANS_ROUTE_SEGMENTS.root}`

export const ALLOCATION_PLANS_ROUTES = {
  root: ALLOCATION_PLANS_ROOT,
  lumpsum: `${ALLOCATION_PLANS_ROOT}/${ALLOCATION_PLANS_ROUTE_SEGMENTS.lumpsum}`,
  sip: `${ALLOCATION_PLANS_ROOT}/${ALLOCATION_PLANS_ROUTE_SEGMENTS.sip}`
} as const
